<script setup>

</script>

<template>
<div class="p-3 border"></div>
</template>

<style scoped lang="scss">

</style>
